import React from 'react';
import { SVGProps } from './type';

const Icon = ({ fill }: SVGProps) => (
  <>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M20.4583 19.4846L16.3368 15.3631C17.6413 13.9947 18.4422 12.1419 18.4422 10.1021C18.4422 5.89042 15.028 2.4762 10.8163 2.4762C6.60466 2.4762 3.19043 5.89042 3.19043 10.1021C3.19043 14.3138 6.60466 17.728 10.8163 17.728C12.1197 17.728 13.3466 17.401 14.4197 16.8246L18.769 21.1739C19.2355 21.6404 19.9918 21.6404 20.4583 21.1739C20.9248 20.7075 20.9248 19.9511 20.4583 19.4846ZM16.1313 10.1021C16.1313 13.0375 13.7517 15.4171 10.8163 15.4171C7.88092 15.4171 5.50131 13.0375 5.50131 10.1021C5.50131 7.16669 7.88092 4.78707 10.8163 4.78707C13.7517 4.78707 16.1313 7.16669 16.1313 10.1021Z"
      fill={fill}
    />
    <mask
      id="mask0_2062_11279"
      style={{ maskType: 'alpha' }}
      maskUnits="userSpaceOnUse"
      x="3"
      y="2"
      width="18"
      height="20"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.4583 19.4846L16.3368 15.3631C17.6413 13.9947 18.4422 12.1419 18.4422 10.1021C18.4422 5.89042 15.028 2.4762 10.8163 2.4762C6.60466 2.4762 3.19043 5.89042 3.19043 10.1021C3.19043 14.3138 6.60466 17.728 10.8163 17.728C12.1197 17.728 13.3466 17.401 14.4197 16.8246L18.769 21.1739C19.2355 21.6404 19.9918 21.6404 20.4583 21.1739C20.9248 20.7075 20.9248 19.9511 20.4583 19.4846ZM16.1313 10.1021C16.1313 13.0375 13.7517 15.4171 10.8163 15.4171C7.88092 15.4171 5.50131 13.0375 5.50131 10.1021C5.50131 7.16669 7.88092 4.78707 10.8163 4.78707C13.7517 4.78707 16.1313 7.16669 16.1313 10.1021Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask0_2062_11279)">
      <rect
        x="-26.0957"
        y="-27.9932"
        width="76.1905"
        height="76.1905"
        fill="none"
      />
    </g>
  </>
);

export default Icon;
